/**
 * Whether the home page's hero film plays: the rule on its own, apart from the DOM, so it can be tested.
 *
 * <p>Until 2026-09-29 the film waited for a second visit. That needed a count in the visitor's browser,
 * the count needed consent, and asking for it was what the consent dialog on every first visit was
 * really for. Niklas chose the film over the dialog, so the count is gone. The film is decoration this
 * site serves itself and needs no consent of its own. It plays on a wide screen for a visitor who has
 * asked neither for less motion nor to save data. Only the YouTube delivery still waits for consent,
 * because YouTube sets cookies of its own.</p>
 */

/** How the film reaches the page: a file this site serves, or YouTube's embedded player. */
export type HeroFilmDelivery = "self-hosted" | "youtube";

/** What the rule looks at, read from the browser by the caller. */
export interface HeroFilmConditions {
  delivery: HeroFilmDelivery;
  /** The screen is at least as wide as the hero's own breakpoint. */
  wide: boolean;
  /** The visitor has asked the system for less motion. */
  reducedMotion: boolean;
  /** The visitor has asked the browser to save data. */
  savingData: boolean;
  /** The visitor has allowed content embedded from Google and YouTube. */
  embedConsent: boolean;
}

/** True when the hero film may play under these conditions. */
export function mayPlay(conditions: HeroFilmConditions): boolean {
  if (!conditions.wide || conditions.reducedMotion || conditions.savingData) {
    return false;
  }

  return conditions.delivery === "self-hosted" || conditions.embedConsent;
}
